import React from 'react';

const EnvelopeOutline = ({ className }) => (
    <svg role="img" className={className} viewBox="0 0 24 18">
        <title>ico / mail</title>
        <g id="Finals" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Flow---Masthead---closed" transform="translate(-1270.000000, -19.000000)" fill="currentColor" fillRule="nonzero">
                <g id="Group-10" transform="translate(0.000000, -1.000000)">
                    <g id="Masthead-/-icon-menu-trigger" transform="translate(1254.000000, 1.000000)">
                        <g id="Group" transform="translate(16.000000, 19.000000)">
                            <g id="Shape" transform="translate(0.000000, -0.000000)">
                                <path d="M22.2857143,0 L1.71428571,0 C0.767511857,0 0,0.767511857 0,1.71428571 L0,15.4285714 C0,16.3753453 0.767511857,17.1428571 1.71428571,17.1428571 L22.2857143,17.1428571 C23.2324881,17.1428571 24,16.3753453 24,15.4285714 L24,1.71428571 C24,0.767511857 23.2324881,0 22.2857143,0 Z M20.4,1.71428571 L12,7.52571429 L3.6,1.71428571 L20.4,1.71428571 Z M1.71428571,15.4285714 L1.71428571,2.49428571 L11.5114286,9.27428571 C11.8052525,9.47812035 12.1947475,9.47812035 12.4885714,9.27428571 L22.2857143,2.49428571 L22.2857143,15.4285714 L1.71428571,15.4285714 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default EnvelopeOutline;
